import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Custom log function
import createNewPhoto from "../create/createNewPhoto.js";

// Upload photos function
const uploadPhotoNew = async (folderId, docId, token, prefix) => {
  try {
    // Create a promise that resolves when files are selected
    const selectFiles = () => {
      return new Promise((resolve, reject) => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.accept = "image/*"; // Limit to images only

        input.onchange = () => {
          if (input.files && input.files.length > 0) {
            resolve(input.files);
          } else {
            reject(new Error("No files selected"));
          }
        };

        input.onerror = () => reject(new Error("Error selecting files"));

        // Trigger the file input dialog
        input.click();
      });
    };

    // Allow user to pick files
    const files = await selectFiles();

    // Process each file selected
    for (const file of files) {
      const new_id = await createNewPhoto(
        folderId,
        token,
        "Photo",
        "",
        docId,
        prefix
      );

      const fileBytes = await file.arrayBuffer();
      const url = `${prefix}folders/${folderId}/documents/${docId}/photo/${new_id}`;

      const formData = new FormData();
      formData.append("file", new Blob([fileBytes]), file.name);

      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let start = new Date();

      const response = await fetch(url, {
        method: "POST",
        headers,
        body: formData,
      });

      const auth = getAuthCentral();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("No authenticated user found.");
        return;
      }

      // Check response status
      if (response.ok) {
      } else {
        console.error(`Error uploading file: ${response.status}`);
      }
    }
  } catch (error) {
    console.error("Error selecting or uploading files:", error);
  }
};

export default uploadPhotoNew;
